import styled from 'styled-components';
import { desktop_breakpoint_extended } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

export const BreadcrumbStyles = styled.nav`
  padding: 32px 32px 0;

  .breadcrumb {
    display: flex;
    flex-wrap: wrap;
    list-style: none;

    .breadcrumb-item + .breadcrumb-item {
      &:before {
        content: '\\203A';
        display: inline-block;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
      }
    }
  }

  @media screen and (min-width: ${desktop_breakpoint_extended}px) {
    display: none;
  }
`;
